import { render, staticRenderFns } from "./applyNotar.vue?vue&type=template&id=d00708ce"
import script from "./applyNotar.vue?vue&type=script&lang=js"
export * from "./applyNotar.vue?vue&type=script&lang=js"
import style0 from "./applyNotar.vue?vue&type=style&index=0&id=d00708ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports